exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-503375ca]{width:100%}", ""]);

// exports
